module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/pension/pension.component.css
// module id = ./src/app/sainik-registration/pension/pension.component.css
// module chunks = main